// extracted by mini-css-extract-plugin
export default {"cardUploadField":"Doc_cardUploadField__gzjPR","alert":"Doc_alert__r3dXS"};